import type {
  ITeacherModuleAttendanceResponse,
  ITeacherModuleAttendanceStudent,
  ITeacherModuleAttendanceLesson,
} from '@/entities/TeacherAttendance';

export function transformModuleAttendanceForTable(
  data: ITeacherModuleAttendanceResponse | undefined,
): {
  students: ITeacherModuleAttendanceStudent[];
  valueMap: Map<string, number>;
  lessons: ITeacherModuleAttendanceLesson[];
} {
  const students = data?.students ?? [];
  const lessons = data?.lessons ?? [];
  const valueMap = new Map<string, number>();

  lessons.forEach((lesson) => {
    lesson.attendances.forEach((att) => {
      valueMap.set(
        `${att.student.enrollmentId}-${lesson.groupLessonId}`,
        att.value,
      );
    });
  });

  return { students, valueMap, lessons };
}
